import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 pt-32 pb-20 bg-white shadow-lg">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Privacy Policy</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-green-500 mx-auto rounded-full"></div>
        </div>
      <div className="prose prose-lg text-gray-700">
        <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
    <p>
      This Privacy Policy describes how personal information is collected, used,
      shared, and protected when you visit or use <strong>ecnexus.co</strong>.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Information Collected</h2>
    <p>The Website may collect:</p>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>Personal contact details you submit (name, email, phone, etc.).</li>
      <li>Identifiers required for regulatory purposes (such as PAN, GSTIN), if applicable to users or clients.</li>
      <li>Analytics and technical data (IP address, browser, device, visit duration, interactions).</li>
      <li>Information generated in the course of a consulting relationship.</li>
    </ul>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Use of Information</h2>
    <p>Personal data may be used for:</p>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>Responding to inquiries and communication.</li>
      <li>Fulfilling consulting services and agreements.</li>
      <li>Improving Website functionality and user experience.</li>
      <li>Complying with legal and regulatory requirements.</li>
      <li>Security monitoring and fraud prevention.</li>
    </ul>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Information Sharing</h2>
    <p>Personal data will not be sold, rented, or transferred to third parties, except:</p>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>With trusted service providers (e.g. infrastructure vendors, analytics providers) bound by confidentiality agreements, only as needed.</li>
      <li>As required by law, regulation, or legal process.</li>
      <li>With explicit user consent.</li>
    </ul>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Retention</h2>
    <p>
      Personal data is retained only as long as needed to fulfill its purpose, comply with regulatory obligations, or until the user requests deletion (subject to legal retention requirements).
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Data Security and Breach Notification</h2>
    <p>
      Reasonable technical and organizational measures (encryption, secure storage, access controls) are implemented to protect your data. In the event of a data breach, affected users will be notified promptly, as required by applicable law.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. User Rights</h2>
    <p>You have these rights:</p>
    <ul className="list-disc pl-6 mt-4 space-y-2">
      <li>Access your personal data on request.</li>
      <li>Request correction or deletion of your data.</li>
      <li>Restrict or object to the processing of your data.</li>
      <li>Withdraw consent for use of your data.</li>
    </ul>
    <p>Requests can be made using the Website’s contact form.</p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Cookies and Tracking</h2>
    <p>
      Cookies and similar technologies may be used to analyze Website traffic and enhance user experience. Users may set browser preferences to manage cookies, but some features may not function if cookies are blocked.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. International Data Transfers</h2>
    <p>
      If you access the Website from outside India, your data may be processed in India and be subject to local law.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Children’s Privacy</h2>
    <p>
      This Website is not intended for users under 18. Personal information of minors will be deleted if discovered.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Third-Party Links</h2>
    <p>
      The Website may link to external sites. The owner is not responsible for their privacy practices or content.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Policy Updates</h2>
    <p>
      This Policy may be updated periodically. Changes will be posted here. Continued use after changes implies acceptance.
    </p>
  </section>

  <section className="mb-10">
    <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Contact</h2>
    <p>
      For any questions or requests regarding this Policy, please use the contact form on the Website.
    </p>
  </section>

        <div className="mt-12 border-t pt-8">
          <p className="text-sm text-gray-500">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          <p className="mt-2">
            For any questions about this policy, please contact us at info@ecnexus.co
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;